export const fnbURL = "https://sapp.mycw.in/fnbordering/graphql";
export const serverUrl = "https://s360app.mycw.in/cw-retail/graphql";